import React, { useMemo } from 'react';
import { colorPickerColors } from 'constants/colors';

interface InitialsImageProps {
  name: string;
}

const InitialsImage = ({ name }: InitialsImageProps) => {
  const initials = useMemo(() => {
    if (!name) return '';

    const [firstName, lastName] = name.split(' ');
    return `${firstName[0]}${lastName ? lastName[0] : ''}`;
  }, [name]);

  if (!name) return null;

  return (
    <span
      className="contact-initials"
      style={{ backgroundColor: colorPickerColors[name.length % colorPickerColors.length] }}
    >
      {initials}
    </span>
  );
};

export default InitialsImage;
